import { defineModule } from "@motolynk/app-core";

import en from "./i18n/en.json";

const dashboardNav = {
  id: "dashboard",
  group: "main",
  label: "core:nav.dashboard",
  icon: "dashboard",
  to: "/",
  order: 0,
} as const;

export const coreModule = defineModule({
  name: "core",
  label: "Core",
  i18n: { en },
  admin: {
    routes: [{ path: "/", page: () => import("./admin/DashboardPage") }],
    nav: [dashboardNav],
  },
  vendor: {
    routes: [
      { path: "/", page: () => import("./vendor/DashboardPage") },
      // Full-screen (no sidebar) until the vendor is approved; vendors module takes over in P3-01.
      { path: "onboarding", layout: "bare", page: () => import("./vendor/OnboardingPage") },
    ],
    nav: [dashboardNav],
  },
});
